var calls;
(function (calls) {
    calls[calls["findCompletedItems"] = 0] = "findCompletedItems";
    calls[calls["findItemsAdvanced"] = 1] = "findItemsAdvanced";
    calls[calls["findItemsByCategory"] = 2] = "findItemsByCategory";
    calls[calls["findItemsByKeywords"] = 3] = "findItemsByKeywords";
    calls[calls["findItemsByProduct"] = 4] = "findItemsByProduct";
    calls[calls["findItemsIneBayStores"] = 5] = "findItemsIneBayStores";
    calls[calls["getHistograms"] = 6] = "getHistograms";
    calls[calls["getSearchKeywordsRecommendation"] = 7] = "getSearchKeywordsRecommendation";
    calls[calls["getVersion"] = 8] = "getVersion";
})(calls || (calls = {}));
export default calls;
